"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Company = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxForm = require("redux-form");

var _CompanyPanel = require("../../components/company/CompanyPanel");

var _CompanyPanel2 = _interopRequireDefault(_CompanyPanel);

var _company = require("../../redux/modules/company");

var _companyInfoValidator = require("./companyInfoValidator");

var _companyInfoValidator2 = _interopRequireDefault(_companyInfoValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Company = exports.Company = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Company, _Component);

  function Company() {
    (0, _classCallCheck3.default)(this, Company);
    return (0, _possibleConstructorReturn3.default)(this, (Company.__proto__ || (0, _getPrototypeOf2.default)(Company)).apply(this, arguments));
  }

  (0, _createClass3.default)(Company, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          company = _props.company,
          loadCompany = _props.loadCompany;

      var nextCompany = nextProps.company;

      if (company.userChangeLoading && !company.userChangeSuccess && !nextCompany.userChangeLoading && nextCompany.userChangeSuccess) {
        loadCompany();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _props2 = this.props,
          company = _props2.company.company,
          pushRoute = _props2.pushRoute;

      if (!company || !company.users) {
        pushRoute("/");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var company = this.props.company.company;

      if (!company || !company.users) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Oma yritys" }),
        _react2.default.createElement(_CompanyPanel2.default, (0, _extends3.default)({}, this.props, {
          company: this.props.company.company,
          companyProps: this.props.company
        }))
      );
    }
  }]);
  return Company;
}(_react.Component), _class.propTypes = {
  company: _react.PropTypes.object.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  updateBillingInfo: _react.PropTypes.func.isRequired,
  loadCompany: _react.PropTypes.func.isRequired,
  changeRole: _react.PropTypes.func.isRequired,
  removeUser: _react.PropTypes.func.isRequired,
  approveUser: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    company: state.company
  };
}, {
  updateBillingInfo: _company.updateBillingInfo,
  changeRole: _company.changeRole,
  removeUser: _company.removeUser,
  approveUser: _company.approveUser,
  loadCompany: _company.load,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "billingInfoForm",
  fields: ["business_id", "company_name", "address", "postal_area", "postal_code"],
  validate: _companyInfoValidator2.default
})(Company));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Company/Company.js
 ** module id = 1209
 ** module chunks = 0
 **/